import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import axios from 'config/axios';
import { ReactQueryKeys } from 'config/constant';
import {
  fetchBannerAndTestimonialsDataSuccess,
  fetchBannerAndTestimonialsDataFailure,
  fetchBannerAndTestimonialsData,
} from 'redux/actions/homepage';
import { useApiDefaults } from './useApiDefaults';
import { refetchOnWindowFocus } from 'config/reactQuery';

export function useBannerAndTestimonialsData() {
  const dispatch = useDispatch();
  const apiDefaults = useApiDefaults();
  const queryClient = useQueryClient();
  const queryKey = [ReactQueryKeys.BANNER_AND_TESTIMONIALS_DATA, apiDefaults];

  const fetchData = async () => {
    const cachedData = queryClient.getQueryData(queryKey);
    if (!cachedData) {
      dispatch(fetchBannerAndTestimonialsData());
    }
    try {
      const response = await axios.post('/AogGetBannerAndTestimonials', apiDefaults);
      dispatch(fetchBannerAndTestimonialsDataSuccess(response.data.data));
      return response.data.data;
    } catch (error) {
      dispatch(
        fetchBannerAndTestimonialsDataFailure({ error: error.data?.message })
      );
      throw error;
    }
  };

  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: fetchData,
    enabled: !!apiDefaults,
    refetchOnWindowFocus,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
}
